'use client';

import { useEffect } from 'react';

export function DomReconcileGuard() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Defensive patch: Prevent React commit-phase crashes caused by
    // browser extensions (Google Translate, Grammarly) or external DOM mutations
    // calling removeChild on nodes whose parent has already been detached.
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function <T extends Node>(child: T): T {
      if (!child || child.parentNode !== this) {
        return child;
      }
      return originalRemoveChild.apply(this, [child]) as T;
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
      if (referenceNode && referenceNode.parentNode !== this) {
        return newNode;
      }
      return originalInsertBefore.apply(this, [newNode, referenceNode]) as T;
    };

    // In local development, purge any stale Service Worker caches from browser storage
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      if ('caches' in window) {
        caches.keys().then((keys) => {
          keys.forEach((key) => {
            if (key.includes('crm-static') || key.includes('workbox') || key.includes('next')) {
              caches.delete(key);
            }
          });
        }).catch(() => {});
      }
    }
  }, []);

  return null;
}
